// Provides ReactDOM to Module Federation remotes via the shared scope.
// window.ReactDOM is set by setupMfGlobals.js at host startup.
module.exports = typeof window !== 'undefined' ? window.ReactDOM : undefined;
